import { useEffect, useState } from "react";
import { Coins, WalletCards } from "lucide-react";
import { obterResumoMinhaConta, type ResumoMinhaConta } from "../api/minhaConta";
import { BotaoContorno } from "../components/ui/BotaoAcao";
import { ModalCadastro } from "../components/ui/ModalCadastro";
import { useIdioma } from "../i18n/IdiomaProvider";
import { mostrarToastErro } from "../utils/toast";
import styles from "./MinhaContaModal.module.css";

interface MinhaContaModalProps {
  aberto: boolean;
  onFechar: () => void;
}

const INICIAL: ResumoMinhaConta = {
  sucesso: true,
  saldo: 0,
};

function numero(valor: number): string {
  return new Intl.NumberFormat("pt-BR").format(Number(valor || 0));
}

export function MinhaContaModal({ aberto, onFechar }: MinhaContaModalProps) {
  const { traduzir } = useIdioma();
  const [resumo, setResumo] = useState<ResumoMinhaConta>(INICIAL);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState("");

  useEffect(() => {
    if (!aberto) return;
    let ativo = true;
    setCarregando(true);
    setErro("");
    void obterResumoMinhaConta()
      .then((dados) => { if (ativo) setResumo(dados); })
      .catch((falha) => {
        if (!ativo) return;
        const mensagem = falha instanceof Error ? falha.message : "Não foi possível carregar os créditos de IA.";
        setErro(mensagem);
        mostrarToastErro(traduzir(mensagem));
      })
      .finally(() => { if (ativo) setCarregando(false); });
    return () => { ativo = false; };
  }, [aberto, traduzir]);

  return (
    <ModalCadastro
      aberto={aberto}
      onFechar={onFechar}
      titulo="Minha conta"
      subtitulo="Saldo de moedas de IA da organização."
      icone={<WalletCards aria-hidden="true" />}
      largura={920}
      altura={360}
      corpoClassName={styles.corpo}
      exibirOrientacao={false}
      rodape={<div className={styles.rodape}><BotaoContorno onClick={onFechar}>Fechar</BotaoContorno></div>}
    >
      <div className={styles.conteudo}>
        {carregando ? (
          <div className={styles.estado}>{traduzir("Carregando dados da conta...")}</div>
        ) : erro ? (
          <div className={styles.erro}>{traduzir(erro)}</div>
        ) : (
          <>
            <div className={styles.resumoGridSaldo}>
              <article className={`${styles.resumoCard} ${styles.resumoCardMoedas}`}>
                <Coins aria-hidden="true" />
                <span>{traduzir("Saldo disponível")}</span>
                <strong>{numero(resumo.saldo)}</strong>
                <small>{traduzir("moedas de IA")}</small>
              </article>
            </div>
          </>
        )}
      </div>
    </ModalCadastro>
  );
}
